import { render } from "./PoliticaProteccionDatosPage.vue?vue&type=template&id=93d4f34e&scoped=true"
import script from "./PoliticaProteccionDatosPage.vue?vue&type=script&lang=js"
export * from "./PoliticaProteccionDatosPage.vue?vue&type=script&lang=js"

import "./PoliticaProteccionDatosPage.vue?vue&type=style&index=0&id=93d4f34e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d4f34e"]])

export default __exports__